/**
 * Synthetic Demo Session Manager
 * Ensures demo activation is strictly explicit (?demo=thomas or active demo session)
 * and bounded to the local tab session without forging production JWTs.
 */

export const THOMAS_DEMO_PERSONA = Object.freeze({
  id: 'usr-thomas',
  email: 'thomas@talktoplus.io',
  full_name: 'Thomas Nordstrom - Board Director',
  role: 'super_admin',
  title: 'Board Director',
  tenant_id: 'default-tenant',
  demo: true,
});

export const DEMO_SESSION_KEY = 'tkp_synthetic_demo_session';

export function isSyntheticDemoSession(search = '', productMode = 'PRODUCTION') {
  if (typeof window === 'undefined') return false;

  // 1. Explicit search param in URL
  const params = new URLSearchParams(search || (typeof window !== 'undefined' ? window.location.search : '') || '');
  if (params.get('demo') === 'thomas' || params.get('demo') === 'true') return true;

  // 2. Persisted bounded tab session or demo token
  try {
    const sessionActive = sessionStorage.getItem(DEMO_SESSION_KEY) === 'true';
    const userRaw = localStorage.getItem('tkp_user');
    const user = userRaw ? JSON.parse(userRaw) : null;
    const token = localStorage.getItem('tkp_token');
    const isDemoToken = typeof token === 'string' && token.startsWith('demo-token');
    const isDemoEmail = typeof user?.email === 'string' && (user.email.endsWith('@talktoplus.io') || user.email.includes('demo') || user.email.includes('thomas'));
    return sessionActive || Boolean(user?.demo) || Boolean(isDemoToken) || Boolean(isDemoEmail);
  } catch {
    return false;
  }
}


export function resolveSyntheticDemoPersona(search = '', productMode = 'PRODUCTION') {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(search || (typeof window !== 'undefined' ? window.location.search : '') || '');
  const demoParam = params.get('demo');

  if (demoParam === 'thomas') {
    beginSyntheticDemoSession();
    return { ...THOMAS_DEMO_PERSONA };
  }

  if (demoParam && demoParam !== 'thomas') {
    return null;
  }

  // If already marked demo in local/sessionStorage and no conflicting param
  try {
    const sessionActive = sessionStorage.getItem(DEMO_SESSION_KEY) === 'true';
    const userRaw = localStorage.getItem('tkp_user');
    const user = userRaw ? JSON.parse(userRaw) : null;
    if (sessionActive && user?.demo) return user;
  } catch {
    // Ignore parse error
  }

  return null;
}

export function beginSyntheticDemoSession() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(DEMO_SESSION_KEY, 'true');
    localStorage.setItem('tkp_user', JSON.stringify(THOMAS_DEMO_PERSONA));
    localStorage.setItem('tkp_token', 'demo-token-thomas');
  } catch {
    // Ignore storage issues
  }
}

export function endSyntheticDemoSession() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(DEMO_SESSION_KEY);
    localStorage.removeItem('tkp_user');
    localStorage.removeItem('tkp_token');
  } catch {
    // Ignore storage issues
  }
}
